import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { postItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { DebitNote, formatDebitNoteNumber } from "../../models/debit-note";

interface DebitNoteConsultByCdcModalProps {
  show: boolean;
  debitNote?: DebitNote;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DebitNoteConsultByCdcModal: React.FC<DebitNoteConsultByCdcModalProps> = ({
  show,
  debitNote,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = debitNote
    ? `Está seguro de que quiere consultar la nota de débito ${formatDebitNoteNumber(
        debitNote
      )} por CDC?`
    : "";

  const onConsultClick = async () => {
    if (debitNote !== undefined) {
      setSubmitting(true);
      const status = await postItem(
        `/debit_notes/${debitNote.id}/consult_by_cdc/`,
        {}
      );

      if (status.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (status.detail !== undefined) {
          message = status.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-primary" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Consultar por CDC</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onConsultClick} color="primary">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Consultando..." : "Consultar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default DebitNoteConsultByCdcModal;
